var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('img',{staticClass:"successImg",attrs:{"src":require("../../assets/success.png")}}),_c('div',{staticClass:"text1"},[_vm._v("提现申请已提交")]),_c('div',{staticClass:"text2"},[_vm._v("预计到账时间为2小时，具体到账时间根据银行为准")]),_c('div',{staticClass:"button"},[_vm._v("返回首页")])])
}]

export { render, staticRenderFns }